import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncCreateOrganization = createAsyncThunk(
  "/fetchAsyncCreateOrganization",
  async (data) => {
    try {
      const response = await axiosInstance.post('/organization/create', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUpdateOrganizaion = createAsyncThunk(
    "/fetchAsyncUpdateOrganizaion",
    async (data) => {
      try {
        const response = await axiosInstance.post(`/organization/update/${data?.id}`, data?.data);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
  export const fetchAsyncUpdatePaymentLimit = createAsyncThunk(
    "/fetchAsyncUpdatePaymentLimit",
    async (data) => {
      try {
        const response = await axiosInstance.post(`/organization/payment-limit/${data?.id}`, data?.data);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
export const fetchAsyncGetOrganization = createAsyncThunk(
    "/fetchAsyncGetOrganization",
    async () => {
      try {
        let url = `${API_URL}/organization/get`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  export const fetchAsyncGetOrganizationLogo = createAsyncThunk(
    "/fetchAsyncGetOrganizationLogo",
    async () => {
      try {
        let url = `${API_URL}/organization/get-logo`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  export const fetchAsyncGetPaymentLimit = createAsyncThunk(
    "/fetchAsyncGetPaymentLimit",
    async (modId) => {
      try {
        let url = `${API_URL}/organization/pay-limit/${modId}`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
  const AllOrganizationSlice = createSlice({
    name: "organizationData",
    initialState,
    reducers: {},
    extraReducers: {
      [fetchAsyncGetOrganization.pending]: (state) => {},
      [fetchAsyncGetOrganization.fulfilled]: (state, { payload }) => {
        return payload;
      },
    },
  });

  const OrganizationLogoSlice = createSlice({
    name: "logoData",
    initialState,
    reducers: {},
    extraReducers: {
      [fetchAsyncGetOrganizationLogo.pending]: (state) => {},
      [fetchAsyncGetOrganizationLogo.fulfilled]: (state, { payload }) => {
        return payload;
      },
    },
  });
  

  export const getAllOrganization = (state) => state.organizationData;
  export const getOrganizationLogo = (state) => state.logoData;
  
  export const organizationSlice = AllOrganizationSlice.reducer;
export const logoSlice = OrganizationLogoSlice.reducer;



